import { render, staticRenderFns } from "./AdditionalCostsFormRow.vue?vue&type=template&id=0c8d7d54&lang=pug"
import script from "./AdditionalCostsFormRow.vue?vue&type=script&lang=js"
export * from "./AdditionalCostsFormRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports